module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_search-8a98d4f958b4b14aeda9260edb34afc6.svg";